/* eslint-disable react/destructuring-assignment,lines-between-class-members */
import React, { Component, cloneElement } from 'react';
import PropTypes from 'prop-types';
import serialize from 'form-serialize';

import { AUTHENTICITY_TOKEN } from '../../constants/env';
import { customSerializer } from '../../utils/customSerializer';

/*
 * That `cloneElement` thing a little bit hacky, because it won't work if there'll be more
 * than one children. But we also shouldn't put an array of form into this, so everything will be OK
 * Did it to provide more clean code without using loops
 * */

const DEFAULT_ACTION = () => {};

class Form extends Component {
  state = {
    serializedForm: {},
  };

  options = {};
  intl = {};
  form = null;
  action = DEFAULT_ACTION;

  componentWillMount() {
    this.handleSubmit = this.handleSubmit.bind(this);
    this.getAction = this.getAction.bind(this);
    this.getOptions = this.getOptions.bind(this);
    this.getIntl = this.getIntl.bind(this);
  }

  getAction(action) {
    this.action = action || DEFAULT_ACTION;
  }

  getOptions(options) {
    this.options = options;
  }

  getIntl(intl) {
    this.intl = intl;
  }

  handleSubmit(e) {
    e.preventDefault();
    const { formatMessage } = this.intl;

    const serializer = (result, key, value) =>
      customSerializer(result, key, value, formatMessage);
    const serializedForm = serialize(this.form, { hash: true, serializer });
    this.setState({ serializedForm }, () => {
      this.action({
        ...this.state.serializedForm,
        ...this.options,
      });
    });
  }

  render() {
    const { children } = this.props;
    return (
      <form
        action="POST"
        onSubmit={this.handleSubmit}
        ref={node => (this.form = node)}
      >
        {cloneElement(children, {
          serializedForm: this.state.serializedForm,
          getAction: this.getAction,
          getOptions: this.getOptions,
          getIntl: this.getIntl,
        })}
        <input
          type="hidden"
          name="authenticity_token"
          value={AUTHENTICITY_TOKEN}
        />
      </form>
    );
  }
}

Form.propTypes = {
  children: PropTypes.node,
};

Form.defaultProps = {
  children: {},
};

export default Form;



// WEBPACK FOOTER //
// ./src/components/Auth/Form.jsx